(ns livefeed.header
  (:require [reagent.core :as r]
            [livefeed.message-filter :as msg-filter]
            [livefeed.state :as state]
            ["@yleisradio/yds-components-react" :refer [Button]]
            ["@yleisradio/yds-icons-react" :refer [Info Close]]))

(defn component [_ _ _ _]
  (fn [topic-title message-filter on-toggle-maximize on-close on-change-message-filter]
    (let [show-message-filter? (and (nil? @state/label) @state/best-view-enabled?)]
      [:div.yle-livefeed__header
       [:div.yle-livefeed__header__title
        (if show-message-filter?
          [msg-filter/component message-filter on-change-message-filter]
          [:p.yle-livefeed__header__title__text {:title topic-title} topic-title])]
       [:div.yle-livefeed__header__buttons
        [:> Button {:id "cw-maximize-header"
                    :variant "text"
                    :removePadding true
                    :iconOnly true
                    :iconAfter (r/as-element [:> Info])
                    :onClick on-toggle-maximize
                    :size "sm"}]
        (when on-close [:> Button {:id "cw-close-chat"
                                   :className "yle-livefeed__header__button"
                                   :variant "text"
                                   :iconOnly true
                                   :removePadding true
                                   :iconAfter (r/as-element [:> Close])
                                   :onClick on-close
                                   :size "sm"}])]])))
